import {  SET_SELECTED_COMPANY } from './ActionTypes';
import { getItem, setItem } from '../../utils/function';

const INITIAL_STATE = {
  selectedCompany: getItem('selectdCompany')
};
const CompanyReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SELECTED_COMPANY: {
      setItem('selectdCompany', action.payload);
      return {
        ...state,
        selectdCompany: action.payload
      };
    }
    default:
      return state;
  }
};

export default CompanyReducer;
